import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function FAQ() {
    const [expanded, setExpanded] = React.useState<string | false>(false);

    const handleChange =
        (panel: string) =>
        (event: React.SyntheticEvent, isExpanded: boolean) => {
            setExpanded(isExpanded ? panel : false);
        };

    return (
        <Container
            id='faq'
            sx={{
                pt: { xs: 4, sm: 12 },
                pb: { xs: 8, sm: 16 },
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: { xs: 3, sm: 6 },
            }}>
            <Typography
                component='h2'
                variant='h4'
                color='text.primary'
                sx={{
                    width: { sm: '100%', md: '60%' },
                    textAlign: { sm: 'left', md: 'center' },
                }}>
                Questions fréquentes
            </Typography>
            <Box sx={{ width: '100%' }}>
                <Accordion
                    expanded={expanded === 'panel1'}
                    onChange={handleChange('panel1')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls='panel1d-content'
                        id='panel1d-header'>
                        <Typography component='h3' variant='subtitle2'>
                            Suis-je obligé de renseigner une gare de départ ?
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography
                            variant='body2'
                            textAlign={'left'}
                            paddingLeft={2}>
                            Le fonctionnement de l'algorithme requiert une gare
                            de départ pour pouvoir effectuer une recherche.{' '}
                            <br />
                            Il est donc nécessaire de renseigner une gare de
                            départ pour obtenir des résultats.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion
                    expanded={expanded === 'panel2'}
                    onChange={handleChange('panel2')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls='panel2d-content'
                        id='panel2d-header'>
                        <Typography component='h3' variant='subtitle2'>
                            Aucun trajet ne s'affiche
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography
                            variant='body2'
                            textAlign={'left'}
                            paddingLeft={2}>
                            Il se peut qu'il n'y ai pas de trajet avec TGVMAX
                            suivant les critères que vous avez sélectionnés.{' '}
                            <br />
                            Essayez de modifier les critères de votre recherche.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion
                    expanded={expanded === 'panel3'}
                    onChange={handleChange('panel3')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls='panel3d-content'
                        id='panel3d-header'>
                        <Typography component='h3' variant='subtitle2'>
                            Je souhaite renseigner une gare d'arrivée également
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography
                            variant='body2'
                            textAlign={'left'}
                            paddingLeft={2}>
                            Ce site permet de trouver des idées de voyage au
                            départ d'une gare.
                            <br />
                            Si vous connaissez déjà la gare d'arrivée, vous
                            pouvez directement lancer une recherche sur votre
                            site de réservation habituel.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            </Box>
        </Container>
    );
}
